import { InsightContentSettingType } from 'components/insightContent/types'
import { PivotWithCellMarker } from 'components/widget/CrosstabWidgets/types'
import { Pivot } from 'schemas/PivotSchema'
import ComparisonMode from 'enums/ComparisonMode'

const selectEntireRow = (
  detailSetting: InsightContentSettingType,
  selectedColumn: PivotWithCellMarker[]
) => {
  const {
    colComparisonMode,
    selectedPivotThemeInfo,
    selectedTagName,
    selectedDocName
  } = detailSetting

  switch (colComparisonMode) {
    case ComparisonMode.THEMES:
      return selectedColumn?.filter(
        (crossTab: Pivot) => crossTab?.themeId === selectedPivotThemeInfo.themeId!
      )

    case ComparisonMode.TAGS:
      return selectedColumn?.filter((crossTab: Pivot) => crossTab?.tagName === selectedTagName)

    case ComparisonMode.DOC_HIERARCHIES:
      return selectedColumn?.filter((crossTab: Pivot) => crossTab?.docName === selectedDocName)

    default:
      throw new Error(`Unsupported comparison mode: ${colComparisonMode}`)
  }
}

export default selectEntireRow
